import { Injectable } from "@angular/core";

import { ApiGatewayService } from "../api-gateway/api-gateway.service";
import { SnackbarService } from "../snackbar/snackbar.service";
import { AccountInfo } from "../../models";

@Injectable()
export class AccountInfoService {
	private accountInfoPromise: Promise<AccountInfo>;
	private accountInfo?: AccountInfo;

	constructor(
		apiGatewayService: ApiGatewayService,
		snackBarService: SnackbarService
	) {
		this.accountInfoPromise = apiGatewayService.getAccountInfo()
			.then((accountInfo) => {
				this.accountInfo = accountInfo;
				return this.accountInfo;
			})
			.catch((e) => {
				snackBarService.showErrorBar(e);
				throw e;
			});
	}

	public getAccountInfo(): Promise<AccountInfo> {
		if (this.accountInfo) {
			return Promise.resolve(this.accountInfo);
		} else {
			return this.accountInfoPromise;
		}
	}
}
